import React from 'react';
import Prototypes from 'prop-types';
import styles from './Text.module.css';

function Text({ text }) {
  return <h4 className={styles.text}> {text}</h4>;
}

Text.propTypes = {
  text: Prototypes.string.isRequired,
};
export default Text;
